import React, { Component } from 'react';
import { onScrollElemento } from '../modules/util';
import logo from '../../img/logo2.png';
import HomeTecnologias from './home-tecnologias';
import HomeIndex from './home-index';
import HomeNumbers from './home-numbers';
import HomeApps from './home-apps';
import HomeAwards from './home-awards';
import HomeTeam from './home-team';

import About from './about';

import Contact from './contact';

import { posicionar } from '../modules/util';

import queryString from 'query-string';



class Home extends Component {

    componentDidMount() {
        this.pos();


    }

    componentWillReceiveProps() {
        this.pos();
    }

    pos() {
        const parsed = queryString.parse(window.location.search);
        if (parsed && parsed.s) {
            posicionar(parsed.s);
        }


    }

    render() {
        return (
            <div className="home">
                <HomeIndex />
                <HomeTecnologias />
                <HomeNumbers />
                <HomeApps />

                <HomeTeam />
                <HomeAwards />
                <About />
                <Contact />
            </div>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/js/pages/home.js